// eslint-disable-next-line
export const getProcessManagerErrorText = state =>
    state.backendReducer.texts.processManagerErrorClientClosed



// WEBPACK FOOTER //
// ./src/features/Backend/data/texts/selectors.js